export default __webpack_public_path__ + "static/media/correct.8488e033.mp3";